import { Radio } from '@common/components/radio';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';
import { FixedSizeList as List } from 'react-window';

import { User } from './components/user';
import { MODULE_NAME } from '../../../../audit-report';

import './users.styles.scss';

const VALUE_TYPE = {
  all: 'all',
  particular: 'particular',
};

export const Users = (props) => {
  const { className, data = [], value, onChange } = props;
  const [type, setType] = React.useState(value.length ? VALUE_TYPE.particular : VALUE_TYPE.all);

  const options = React.useMemo(() => {
    return [
      {
        label: 'Show Records for All Users',
        value: VALUE_TYPE.all,
      },
      {
        label: 'Show Records for the Following Users:',
        value: VALUE_TYPE.particular,
      },
    ];
  }, []);

  const handleTypeChange = React.useCallback((e) => {
    e.persist();

    setType(e.currentTarget.value);
    onChange([]);
  }, [onChange]);

  const handleUserClick = React.useCallback((id) => {
    const newSelectedUsers = value.includes(id)
      ? value.filter((x) => x !== id)
      : [...value, id];

      onChange(newSelectedUsers);
  }, [onChange, value]);

  const renderUser = React.useCallback(({ index, data, style }) => {
    const username = data[index];

    return (
      <User 
        selected={value.includes(username)}
        key={username}
        username={username}
        style={style}
        onClick={handleUserClick}
      />  
    );
  }, [value, handleUserClick]);

  const getUserKey = React.useCallback((index, data) => {
    return data[index];
  }, []);

  return (
    <section className={cx('FieldAuditReportUsers', className)}>
      {options.map((x) => (
        <Radio
          id={`${MODULE_NAME}-filter-users-type-${x.value}`}
          className="FieldAuditReportUsers__radio" 
          key={x.value} 
          value={x.value} 
          checked={x.value === type} 
          onChange={handleTypeChange}
        >
          {I18n.t(x.label)}
        </Radio>
      ))}
      <List
        className={cx('FieldAuditReportUsers__users', { 'FieldAuditReportUsers__users--disabled': type !== VALUE_TYPE.particular })}
        height={200}
        itemCount={data.length}
        itemSize={20}
        width="100%"
        overscanCount={5}
        itemData={data}
        itemKey={getUserKey}
      >
        {renderUser}
      </List>
    </section>
  );
};